var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDrag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 12C16.6569 12 18 10.6569 18 9C18 7.34315 16.6569 6 15 6C13.3431 6 12 7.34315 12 9C12 10.6569 13.3431 12 15 12Z",
    fill: "#444444"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 24C16.6569 24 18 22.6569 18 21C18 19.3431 16.6569 18 15 18C13.3431 18 12 19.3431 12 21C12 22.6569 13.3431 24 15 24Z",
    fill: "#444444"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 36C16.6569 36 18 34.6569 18 33C18 31.3431 16.6569 30 15 30C13.3431 30 12 31.3431 12 33C12 34.6569 13.3431 36 15 36Z",
    fill: "#444444"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27 12C28.6569 12 30 10.6569 30 9C30 7.34315 28.6569 6 27 6C25.3431 6 24 7.34315 24 9C24 10.6569 25.3431 12 27 12Z",
    fill: "#444444"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27 24C28.6569 24 30 22.6569 30 21C30 19.3431 28.6569 18 27 18C25.3431 18 24 19.3431 24 21C24 22.6569 25.3431 24 27 24Z",
    fill: "#444444"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27 36C28.6569 36 30 34.6569 30 33C30 31.3431 28.6569 30 27 30C25.3431 30 24 31.3431 24 33C24 34.6569 25.3431 36 27 36Z",
    fill: "#444444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrag);
export default __webpack_public_path__ + "static/media/drag.7a69a7a0af67aa853ca8f0dd043a191e.svg";
export { ForwardRef as ReactComponent };